<section class="beneficio">
    <div class="container">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-12 text-center">
                <h3 class="mb-4">{{ data.TITULO }}</h3>
                <p class="mb-0">{{ data.DESCRICAO }}</p>
            </div>
        </div>
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-12">
                <img src="{{ data.IMAGEM }}" class="img-fluid"/>
            </div>
        </div>
    </div>
</section>
